import { AssetAllocationCategory } from '@/cip/_openapi/portfolio-optimizer';

export const ChartColors = [
    '#255C64', // Dark teal
    '#B6E3C0', // Light mint green
    '#C6E6E6', // Light blue-gray
    '#E8FEBA', // Light lime
    '#D3CEC7', // Light beige
    '#D87171', // Coral red
    '#8B7FB8', // Lavender purple
    '#F4C2A1', // Peach
    '#A8C8EC', // Soft blue
    '#F7D794', // Soft yellow
    '#FFB6C1', // Light pink
    '#98D8E8', // Sky blue
    '#DDA0DD', // Plum
    '#F0E68C', // Khaki
    '#87CEEB', // Sky blue
    '#DEB887', // Burlywood
    '#F5DEB3', // Wheat
    '#D2B48C', // Tan
    '#BC8F8F', // Rosy brown,
    '#B08962', // Warm brown
];

const CATEGORY_COLORS: Partial<Record<AssetAllocationCategory, string>> = {
    [AssetAllocationCategory.NET_US_EQUITY_RATIO]: ChartColors[0],
    [AssetAllocationCategory.NET_NON_US_EQUITY_RATIO]: ChartColors[1],
    [AssetAllocationCategory.NET_US_BOND_RATIO]: ChartColors[2],
    [AssetAllocationCategory.NET_NON_US_BOND_RATIO]: ChartColors[8],
    [AssetAllocationCategory.NET_CASH_RATIO]: ChartColors[3],
    [AssetAllocationCategory.NET_OTHER_RATIO]: ChartColors[4],
    [AssetAllocationCategory.UNCATEGORIZED]: ChartColors[5],
};

export const getCategoryColor = (category: AssetAllocationCategory): string =>
    CATEGORY_COLORS[category] ?? ChartColors[6];
